var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42944 1.59961H15.5694V13.3903H8.42944V1.59961Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16589 7.50288C9.16501 6.36754 9.41957 5.24688 9.91029 4.22569C10.401 3.2045 11.1151 2.30956 11.9984 1.60858C10.9044 0.739263 9.59049 0.198688 8.20696 0.0486345C6.82344 -0.101419 5.42606 0.145102 4.17455 0.760023C2.92304 1.37494 1.86789 2.33346 1.12968 3.52601C0.391474 4.71856 0 6.09704 0 7.50391C0 8.91077 0.391474 10.2893 1.12968 11.4818C1.86789 12.6744 2.92304 13.6329 4.17455 14.2478C5.42606 14.8627 6.82344 15.1092 8.20696 14.9592C9.59049 14.8091 10.9044 14.2686 11.9984 13.3992C11.1148 12.698 10.4006 11.8028 9.90984 10.7812C9.4191 9.75961 9.1647 8.63854 9.16589 7.50285V7.50288Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2874 12.1451V11.9035H23.3904V11.8535H23.1453V11.9035H23.2421V12.1451L23.2874 12.1451ZM23.7632 12.1451V11.8536H23.6891L23.6026 12.0618L23.516 11.8535H23.4419V12.1451H23.4954V11.9243L23.5758 12.1139H23.6314L23.7118 11.9243V12.1451H23.7632Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.998 7.49999C23.998 8.90696 23.6064 10.2855 22.8681 11.4781C22.1298 12.6707 21.0744 13.6292 19.8228 14.2441C18.5711 14.8589 17.1736 15.1052 15.79 14.955C14.4064 14.8047 13.0925 14.2639 11.9985 13.3943C12.8815 12.6927 13.5953 11.7975 14.0862 10.7762C14.5771 9.75499 14.8321 8.63438 14.8321 7.49893C14.8321 6.36349 14.5771 5.24287 14.0862 4.22163C13.5953 3.20039 12.8815 2.3052 11.9985 1.6036C13.0925 0.73401 14.4064 0.193166 15.79 0.0428935C17.1736 -0.107379 18.5711 0.138984 19.8228 0.75382C21.0745 1.36866 22.1298 2.32716 22.8681 3.51976C23.6065 4.71236 23.998 6.09094 23.998 7.49791V7.49999Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/masterCard.99ad409b7fd4afd9134ebe07f3ac8d36.svg";
export { ForwardRef as ReactComponent };